import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import toast from "react-hot-toast";

const ROUTE_MESSAGES = {
  "/shipping-address": "Please sign in to view the Shipping Address page.",
  "/account/orders": "Please sign in to view My Orders.",
};

const SignedInRoute = ({ redirectPath = "/" }) => {
  const location = useLocation();

  const isAuthenticated =
    typeof window !== "undefined" && Boolean(localStorage.getItem("authToken"));

  const message =
    ROUTE_MESSAGES[location.pathname] || "Please sign in to view this page.";

  useEffect(() => {
    if (!isAuthenticated) {
      toast.error(message, {
        id: `auth-required-${location.pathname}`,
      });
    }
  }, [isAuthenticated, location.pathname, message]);

  if (!isAuthenticated) {
    return (
      <Navigate
        to={redirectPath}
        replace
        state={{
          authRequired: true,
          authMessage: message,
          returnTo: location.pathname,
        }}
      />
    );
  }

  return <Outlet />;
};

export default SignedInRoute;
